(async () => {
  if (!customElements.get('toggle-text')) {
    class ToggleText extends HTMLElement {
      constructor() {
        super();

        // Element
        this.targetElement = this.querySelector('[data-target]');
        this.contentElement = this.querySelector('[data-content]');
        this.triggerElement = this.querySelector('[data-trigger]');

        // setToggleState
        window.addEventListener('load', () => {
          this.setToggleState();
        });

        // Events
        window.addEventListener('resize', () => {
          this.classList.remove('no-toggle');
          this.classList.remove('has-toggle');
          this.classList.remove('open');
          this.setToggleState();
        });

        this.triggerElement.addEventListener('click', () => {
          this.classList.toggle('open');
        });
      }

      /**
       * setToggleState
       */
      setToggleState() {
        if (this.contentElement.offsetHeight > this.targetElement.offsetHeight) {
          this.classList.remove('no-toggle');
          this.classList.add('has-toggle');
        } else {
          this.classList.remove('has-toggle');
          this.classList.add('no-toggle');
        }
      }
    }

    window.ToggleText = ToggleText;

    customElements.define('toggle-text', ToggleText);
  }
})();
